import { schema, types } from 'papr'

export const docsRedirectsSchema = schema(
	{
		pageId: types.objectId(),
		guideId: types.objectId({ required: true }),
		versionId: types.objectId({ required: true }),
		projectId: types.objectId({ required: true }),
		/**
		 * The old path or slug
		 */
		path: types.string({ required: true }),
	},
	{
		timestamps: true,
	},
)

export type DocsRedirectsSchemaDocument = (typeof docsRedirectsSchema)[0]
export type DocsRedirectsSchemaOptions = (typeof docsRedirectsSchema)[1]
